// extracted by mini-css-extract-plugin
export default {"badge":"MorePage_badge__yBdTr"};